const apiEndpoints = {
  users: 'users',
  countries: 'countries',
  coupons: 'coupons',
  equipments: 'equipments',
  equipmentTypes: 'equipment-types',
  players: 'players',
  configurations: 'configurations',
  streams: 'streams',
  orders: 'orders',
  videos: 'videos',
  events: 'events',
  games: 'games',
  eventDays: 'event-days',
  slides: 'slides',
  eventTypes: 'event-types',
  audienceReports: 'audience-reports',
  news: 'news',
  sponsors: 'sponsors',
  sports: 'sports',
  languages: 'languages',
  rankings: 'rankings',
  eventVideos: 'event-videos',
  // ...
  // Add other endpoints as needed
};

export default apiEndpoints;